import React, { useEffect } from 'react';
import {
  Nav,
  NavLink,
  Bars,
  NavMenu
} from './NavbarElements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import './internal-navbar.scss';

var hasFlipped = "False";

function openNav(){
	if (hasFlipped === "True") {
		document.getElementById("nav").style.display = "none";
		hasFlipped = "False";
	}
	else if(hasFlipped === "False"){
		document.getElementById("nav").style.display = "flex";
		hasFlipped = "True";
	}

}


function Navbar() {
  //const [desktop, setDesktop] = useState(false);


  useEffect(() => {
    //browser listener on media with criteria max-width
    //if matched , the const show=true otherwise it is set to false
    const media = window.matchMedia("(min-width: 767px)");
    media.addEventListener("change", () => {
      if (media.matches) {
        //setDesktop(true);
        document.getElementById("nav").style.display = "flex";
       }
       else {
        //setDesktop(false);
        document.getElementById("nav").style.display = "none";

       }
    });
  }, []);
  
  return (
    <>
    <div className='internal-nav'>
        <div className='hi-hat'>
          <div className='logo'>
              <h1>BC Surface Supply</h1>
            </div>
            <div className='top-nav'>
          <div className='tippy-top'>
            <div>
        <FontAwesomeIcon icon={faMobileAlt} />
          <a href='tel:2603213092'>(260) 321-3092</a>
          </div>
          <div>
            <FontAwesomeIcon icon={faLocationDot} />
            <a href="https://maps.google.com">5216 Keystone Drive, Fort Wayne, IN 46825</a>
          </div>
      </div>
          <Nav>
          
            <Bars id={"hamburger"} onClick={openNav} />
            
            <NavMenu id={"nav"}>
              <NavLink to='/' >
                Home
              </NavLink>
              <NavLink to='/cabinets' >
                Cabinets
              </NavLink>
              <NavLink to='/countertops' >
                Multi-Family Countertops
              </NavLink>
              <NavLink to='/custom-countertops' >
                Custom Countertops
              </NavLink>
              <NavLink to='/configure' >
            Kitchen Configurator
          </NavLink>                       
          <NavLink to='/contractors-showroom' >
            Contractor's Showroom
          </NavLink>          
          <NavLink to='/flooring' >
                Flooring
              </NavLink>
              <NavLink to='/sinks' >
                Sinks
              </NavLink>
              <NavLink to='/gallery' >
                Gallery
              </NavLink>
              <NavLink to='/team' >
                Our Team
              </NavLink>
              <NavLink to='/contact' >
                Contact
              </NavLink>
            </NavMenu>
            {/* <NavBtn>
                  <NavBtnLink to='/search'>Search</NavBtnLink>
                </NavBtn> */}
          </Nav>
            </div>
            </div>
            </div>
    </>
  );
}
  
export default Navbar;